export type ComboItemsType = 'combo' | 'items';

export interface BumpsProps {
	id?: string;
	product_id: number;
	offers: BumpOffersProps[];
	title: string;
	description: string;
	editing?: boolean;
	type?: BumpType;
	items_type?: ComboItemsType;
	itens_free?: boolean;
	image?: string;
}

export interface BumpOffersProps {
	next_charge_price: number;
	interval: string;
	trial_days: number;
	id: number;
	name: string;
	code: string;
	image: string;
	from_price: number;
	price: number;
	product_id: number;
	type_of_charge?: string;
	highlight_image?: boolean;
	product?: {
		type: string;
	};
}

export enum BumpType {
	MAIN = 'main',
	BUMP = 'bump',
	COMBO = 'combo',
}
